export default function createQueryString(obj) {
  return Object.keys(obj)
    .map(_ => `${encodeURIComponent(_)}=${encodeURIComponent(obj[_])}`)
    .join('&');
}
